export default __webpack_public_path__ + "static/media/key.ec05470a.svg";